import * as React from "react";
import ModalComponent, {ModalSizes} from "../../_widgets/modal/ModalComponent";
import { withGoogleMap, GoogleMap, Marker } from "react-google-maps";
import withScriptjs from "react-google-maps/lib/async/withScriptjs";
import * as _ from "lodash";
import LoadingIndicatorComponent from "../../_widgets/loadingIndicator/LoadingIndicatorComponent";
import Shop from "../../_data/models/Shop";

interface Props {
    active: boolean;
    shop: Shop;
    close: () => void;
}

const AsyncShopMap = _.flowRight(
    withScriptjs,
    withGoogleMap,
)(props => {

    return (
        <GoogleMap defaultZoom={15} center={props.center}>
            {props.markers.map(marker => (
                <Marker {...marker} />
            ))}
        </GoogleMap>
    )
});

const ShopMapModalComponent = (props: Props) => {
    const {active, close, shop} = props;
    const markers = [{
        position: {
            lat: shop.latitude,
            lng: shop.longitude,
        },
        key: "shop_marker_"+shop.id,
        defaultAnimation: 2
    }];

    return (
        <ModalComponent show={active} onExit={close} size={ModalSizes.SMALL} className="">
            <div id="followingModal">
                <div className="reveal-heading">
                    <h5>View Map</h5>
                    <button className="close-button" type="button" onClick={(e) => {e.preventDefault(); close()}}>
                        <span>&times;</span>
                    </button>
                </div>

                {/* todo: set height to be dynamic */}
                {/* todo: externalize api key!! */}
                <AsyncShopMap
                    googleMapURL="https://maps.googleapis.com/maps/api/js?v=3.exp&key=AIzaSyBhpGXiYVzuFj5E5ahGg-oVbdvILnpYuG0"
                    loadingElement={<LoadingIndicatorComponent />}
                    containerElement={
                        <div style={{width: `100%`, height: 400}} />
                    }
                    mapElement={
                        <div style={{width: `100%`, height: `100%`}} />
                    }
                    onMapLoad={_.noop}
                    onMapClick={_.noop}
                    markers={markers}
                    onMarkerRightClick={_.noop}
                    center={{ lat: shop.latitude, lng: shop.longitude }}
                />
            </div>
        </ModalComponent>
    );
};

export default ShopMapModalComponent;


// WEBPACK FOOTER //
// ./app/client/shop/components/ShopMapModalComponent.tsx